// extracted by mini-css-extract-plugin
export default {"profilePage":"profile-details-page_profilePage__-C2Pl","chosenTabWrapper":"profile-details-page_chosenTabWrapper__mL7CU"};